import { useMemo, useState } from 'react';
import { useColleagues, type Colleague } from '../../hooks/useColleagues';

interface Props {
  onSelect: (c: Colleague) => void;
}

const teamLabels: Record<string, string> = {
  route: 'Route',
  wasserij: 'Wasserij',
  algemeen: 'Algemeen',
  kantoor: 'Kantoor',
};

export function ColleaguesDropdown({ onSelect }: Props) {
  const { colleagues, isLoading } = useColleagues();
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return colleagues;
    return colleagues.filter(
      (c) =>
        c.name.toLowerCase().includes(needle) ||
        (c.team ? teamLabels[c.team]?.toLowerCase() ?? c.team.toLowerCase() : '').includes(needle),
    );
  }, [q, colleagues]);

  return (
    <div className="border border-gray-200 rounded-md bg-white shadow-sm overflow-hidden">
      <div className="p-2 border-b border-gray-100">
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Zoek collega of chauffeur..."
          className="w-full text-sm rounded px-2 py-1.5 bg-gray-50 border border-gray-200 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
      </div>

      {isLoading ? (
        <div className="p-2 text-xs text-gray-400">Collega's laden...</div>
      ) : filtered.length === 0 ? (
        <div className="p-2 text-xs text-gray-400">
          {colleagues.length === 0 ? 'Geen collega-nummers gevonden.' : 'Niets gevonden.'}
        </div>
      ) : (
        <ul className="max-h-64 overflow-y-auto divide-y divide-gray-100">
          {filtered.map((c) => (
            <li key={c.id}>
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onSelect(c)}
                className="w-full flex items-center justify-between px-3 py-2 hover:bg-gray-50 text-left"
              >
                <div className="min-w-0">
                  <div className="text-sm text-gray-900 truncate">{c.name}</div>
                  <div className="text-xs text-gray-500">{c.phone}</div>
                </div>
                {c.team && (
                  <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-gray-100 text-gray-600 ml-2 shrink-0">
                    {teamLabels[c.team] ?? c.team}
                  </span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
